import React, { useState } from 'react';
import { LayoutCard, Loading } from '../components';
import TabSection from '../Section/TabSection';
import useListingAppointments from './useListingAppointments';
import useBuyerAppointments from './useBuyerAppointments';

const AppointmentsCard = () => {
  const [tabKey, setTabKey] = useState('buyer');
  const {
    isBuyerAppointmentsLoading,
    buyerAppointments,
    supplementaryTourItems,
    buyerAppointmentsSearchValue,
    setBuyerAppointmentsSearchValue,
  } = useBuyerAppointments();
  const {
    isListingAppointmentsLoading,
    listingAppointments,
    listingAppointmentsSearchValue,
    setListingAppointmentsSearchValue,
  } = useListingAppointments();

  const search =
    tabKey === 'buyer'
      ? {
          searchValue: buyerAppointmentsSearchValue,
          onSearchValueChange: setBuyerAppointmentsSearchValue,
        }
      : {
          searchValue: listingAppointmentsSearchValue,
          onSearchValueChange: setListingAppointmentsSearchValue,
        };

  const tabContents: Record<string, React.ReactElement> = {
    buyer: isBuyerAppointmentsLoading ? (
      <Loading />
    ) : (
      <TabSection
        appointments={buyerAppointments}
        supplementaryTourItems={supplementaryTourItems}
        isBuyer
        showFullTour={buyerAppointmentsSearchValue.length <= 0}
      />
    ),
    listing: isListingAppointmentsLoading ? (
      <Loading />
    ) : (
      <TabSection appointments={listingAppointments} />
    ),
  };

  const buyerLink = '/my_business/showings/buyer';

  const listingLink = '/my_business/showings/listing';

  return (
    <LayoutCard
      search={search}
      titleLink={{
        title: <span data-cy="view-all-appts">Showings</span>,
        linkPath: tabKey === 'buyer' ? buyerLink : listingLink,
      }}
      activeTabKey={tabKey}
      tabList={[
        {
          key: 'buyer',
          tab: <span data-cy="buyer-tab-appts-card">Buyer</span>,
        },
        {
          key: 'listing',
          tab: <span data-cy="listing-tab-appts-card">Listing</span>,
        },
      ]}
      tabProps={{
        size: 'small',
        tabBarExtraContent: <div>Hello</div>,
      }}
      onTabChange={setTabKey}
      data-cy="dashboard-showings-card"
    >
      {tabContents[tabKey]}
    </LayoutCard>
  );
};

export default AppointmentsCard;
